import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Container, Title, SubTitle, Grid, Main } from './styles';
import CardBenefits from './../CardBenefits';
import { iconsFa } from './../../utils/iconsFa';
import api from './../../services/api';
import { ca } from 'date-fns/locale';

export const Benefits = ({ primaryColor, query }) => {
  const [benefits, setBenefits] = useState();

  useEffect(() => {
    async function load() {
      const { label, page_label } = query;

      const benefitUrl =
        page_label && label
          ? `pages/sections/benefit/get/${label}/${page_label}`
          : `pages/sections/benefit/get/${label}`;

      try {
        const { data } = await api.get(benefitUrl);

        // Verificação de segurança para evitar erros quando data é undefined
        if (data && data.data) {
          setBenefits(get(data, 'data', {}));
        } else {
          console.warn('API response data structure is invalid in Benefits component:', data);
          setBenefits({});
        }
      } catch (error) {
        console.error('Error loading benefits:', error);
        setBenefits({});
      }
    }

    let isMoutend = true;

    if (isMoutend && query) {
      load();
    }

    return () => {
      isMoutend = false;
    };
  }, [query]);

  return (
    <Main id="benefits" actived={benefits?.active}>
      <Container>
        <Title>{benefits?.title}</Title>
        <SubTitle>{benefits?.sub_title}</SubTitle>
        <Grid>
          {benefits?.items?.map((benefit, i) => (
            <CardBenefits
              key={i}
              name={typeof benefit?.title === 'string' ? benefit.title : benefit?.title?.value}
              icon={
                iconsFa?.filter(icon => icon.iconName === benefit.icon)[0]?.icon
              }
              primaryColor={primaryColor}
            />
          ))}
        </Grid>
      </Container>
    </Main>
  );
};

Benefits.propType = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  primaryColor: PropTypes.string,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.any.isRequired,
    })
  ),
};
